import { Component, OnInit } from "@angular/core";

@Component({
	standalone: false,
	selector: "ay-page",
	templateUrl: "./ay-page.component.html",
	styleUrls: ["./ay-page.component.scss"],
})
export class AyPageComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
